import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/Sheet/Sheet";
import { CreateRotationForm } from "../../forms/rotations/createRotationForm";
import type { Dispatch, SetStateAction } from "react";

const CreateRotationSheet = ({
  open,
  onOpenChange,
  setRotations,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  setRotations: Dispatch<SetStateAction<{ rotations: any[]; sessions: any[] }>>;
}) => {
  const onSuccess = () => {
    onOpenChange(false);
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right">
        <SheetHeader>
          <SheetTitle>Create Rotation</SheetTitle>
          <SheetDescription>
            Create a new rotation and it's sessions.
          </SheetDescription>
        </SheetHeader>
        <CreateRotationForm onSuccess={onSuccess} setRotations={setRotations} />
      </SheetContent>
    </Sheet>
  );
};

export { CreateRotationSheet };
